import React from 'react';
import { cn } from '@/lib/cn';
import { IconLike, IconDislike } from '@repo/svgs';

export interface SentimentCellProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The type of sentiment to display */
  type?: 'positive' | 'negative';
  /** The label text to display */
  label: string;
}

export function SentimentCell({
  type = 'positive',
  label,
  className,
  ...props
}: SentimentCellProps) {
  const isPositive = type === 'positive';

  return (
    <div className={cn('flex gap-2 items-center', className)} {...props}>
      {/* Icon */}
      {isPositive ? (
        <IconLike className="w-4 h-4 text-success" />
      ) : (
        <IconDislike className="w-4 h-4 text-alert" />
      )}

      {/* Label */}
      <span className="text-body-2 text-primary">{label}</span>
    </div>
  );
}
